import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { AuthRoutingModule } from './../auth/auth-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './../app-routing.module';

import { LibsModule } from './../libs/libs.module';

// Layout
import { LandingPageComponent } from './layouts/landing-page/landing-page.component';
import { CommonPageComponent } from './layouts/common-page/common-page.component';

// Views
import { NotFoundComponent } from './views/not-found/not-found.component';

// Components
import { AsideComponent } from './components/aside/aside.component';
import { CentroDeAyudaComponent } from './views/centro-de-ayuda/centro-de-ayuda.component';
import { ExamensCardItemComponent } from './components/examens-card-item/examens-card-item.component';
import { LastUpdateComponent } from './components/last-update/last-update.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { ModalComponent } from './components/modal/modal.component';
import { ExamFormContainerComponent } from './views/exam-form-container/exam-form-container.component';
import { ExposureAgentsComponent } from './components/exposure-agents/exposure-agents.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { ExamsComponent } from './views/exams/exams.component';
import { ListComponent } from './views/exams/list/list.component';
import { PrimengcomponentsModule } from '@app/primengcomponents/primengcomponents.module';
import { ExamnsTemplateContainerComponent } from './forms/examns-template-container/examns-template-container.component';
import { GroupATemplateComponent } from './forms/templates/group-a-template/group-a-template.component';
import { GroupBTemplateComponent } from './forms/templates/group-b-template/group-b-template.component';
import { GroupCTemplateComponent } from './forms/templates/group-c-template/group-c-template.component';
import { GroupDTemplateComponent } from './forms/templates/group-d-template/group-d-template.component';
import { InvalidFromMessageComponent } from '@app/shared/components/invalid-from-message/invalid-from-message.component';
import { FielTitleComponent } from '@shared/components/fiel-title/fiel-title.component';
import { ExamsFilterComponent } from '@shared/components/exams-filter/exams-filter.component';
import { GroupETemplateComponent } from './forms/templates/group-e-template/group-e-template.component';
import { AttachUploadFileComponent } from './components/attach-upload-file/attach-upload-file.component';

import { NumberReactiveDirective } from '@app/directives/number-reactive.directive';
import { AlphabeticReactiveDirective } from '@app/directives/alphabetic-reactive.directive';
import { PrintButtonComponent } from './components/print-button/print-button.component';
import { AssociatedExamsComponent } from './components/associated-exams/associated-exams.component';
import { PrintFooterComponent } from './components/print-footer/print-footer.component';
import { PrintHeaderComponent } from './components/print-header/print-header.component';
import { GroupFTemplateComponent } from './forms/templates/group-f-template/group-f-template.component';

import { RippleModule } from 'primeng/ripple';
import { AttachedFileMandatoryMessageComponent } from './components/attached-file-mandatory-message/attached-file-mandatory-message.component';
import { GroupGTemplateComponent } from './forms/templates/group-g-template/group-g-template.component';
import { GroupHTemplateComponent } from './forms/templates/group-h-template/group-h-template.component';
import { PrestadorNameFieldComponent } from './components/prestador-name-field/prestador-name-field.component';
import { PrintHeaderUserDataComponent } from './components/print-header-user-data/print-header-user-data.component';
import { GroupKTemplateComponent } from '@shared/forms/templates/group-k-template/group-k-template.component';
import { AlphanumerReactiveDirective } from '@app/directives/alphanumer-reactive.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ListCargadosComponent } from './views/exams/list-cargados/list-cargados.component';
import { ExamsCargadosFilterComponent } from './components/exams-cargados-filter/exams-cargados-filter.component';
import { WorkersFiltersComponent } from './components/workers-filters/workers-filters.component';
import { NoSearchComponent } from './components/no-search/no-search.component';
import {InputMaskModule} from 'primeng/inputmask';
import { ExamensCargadosCardItemComponent } from './components/examens-cargados-card-item/examens-cargados-card-item.component';
import { ShowExamnsTemplateContainerComponent } from './forms/show-examns-template-container/show-examns-template-container.component';
import { EditExamenTemplateContainerComponent } from './forms/edit-examen-template-container/edit-examen-template-container.component';
import { TopazComponent } from './components/topaz/topaz.component';
import { CheckboxQuestionComponent } from './components/checkbox-question/checkbox-question.component';
import { ModalPresentismoComponent } from './components/modal-presentismo/modal-presentismo.component';
import { ModalAusenciaComponent } from './components/modal-ausencia/modal-ausencia.component';
import { ModalCargaExamenPdfComponent } from './components/modal-carga-examen-pdf/modal-carga-examen-pdf.component';
import { AudiometryTableComponent } from './forms/templates/group-f-template/audiometry-table/audiometry-table.component';
import { AgendasComponent } from './views/agendas/agendas.component';
import { AgendasCardItemComponent } from './components/agendas-card-item/agendas-card-item.component';
import { AgendaFormComponent } from './components/agenda-form/agenda-form.component';
import { AgendasFilterComponent } from './components/agendas-filter/agendas-filter.component';
import { ModalResumenComponent } from './components/modal-resumen/modal-resumen.component';
import { ModalAnularAusenciaComponent } from './components/modal-anular-ausencia/modal-anular-ausencia.component';
import { ModalUpdateEmailComponent } from './components/modal-update-email/modal-update-email.component';

@NgModule({
  declarations: [
    LandingPageComponent,
    CommonPageComponent,
    NotFoundComponent,
    HeaderComponent,
    FooterComponent,
    AsideComponent,
    NotFoundComponent,
    CentroDeAyudaComponent,
    ExamensCardItemComponent,
    LastUpdateComponent,
    IconButtonComponent,
    ModalComponent,
    ExamFormContainerComponent,
    ExposureAgentsComponent,
    EmptyStateComponent,
    ExamsComponent,
    ListComponent,
    ExamnsTemplateContainerComponent,
    GroupATemplateComponent,
    GroupBTemplateComponent,
    GroupCTemplateComponent,
    GroupDTemplateComponent,
    InvalidFromMessageComponent,
    FielTitleComponent,
    ExamsFilterComponent,
    GroupETemplateComponent,
    ExamsFilterComponent,
    AttachUploadFileComponent,
    NumberReactiveDirective,
    AlphabeticReactiveDirective,
    AlphanumerReactiveDirective,
    PrintButtonComponent,
    AssociatedExamsComponent,
    PrintFooterComponent,
    PrintHeaderComponent,
    GroupFTemplateComponent,
    AttachedFileMandatoryMessageComponent,
    GroupGTemplateComponent,
    GroupHTemplateComponent,
    PrestadorNameFieldComponent,
    PrintHeaderUserDataComponent,
    GroupKTemplateComponent,
    SafeHtmlPipe,
    ListCargadosComponent,
    ExamsCargadosFilterComponent,
    WorkersFiltersComponent,
    NoSearchComponent,
    ExamensCargadosCardItemComponent,
    ShowExamnsTemplateContainerComponent,
    EditExamenTemplateContainerComponent,
    TopazComponent,
    CheckboxQuestionComponent,
    ModalPresentismoComponent,
    ModalAusenciaComponent,
    ModalCargaExamenPdfComponent,
    AudiometryTableComponent,
    AgendasComponent,
    AgendasCardItemComponent,
    AgendaFormComponent,
    AgendasFilterComponent,
    ModalResumenComponent,
    ModalAnularAusenciaComponent,
    ModalUpdateEmailComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AppRoutingModule,
    AuthRoutingModule,
    LibsModule,
    PrimengcomponentsModule,
    RippleModule,
    InputMaskModule,
    FormsModule
  ],
  exports: [
    LandingPageComponent,
    CommonPageComponent,
    FooterComponent,
    NumberReactiveDirective,
    AlphabeticReactiveDirective,
    AlphanumerReactiveDirective
  ],
})
export class SharedModule {}
